import {Component, Input, AfterViewInit, ViewChild, Output, EventEmitter, OnChanges, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {UntypedFormGroup, FormControl, UntypedFormBuilder, Validators} from '@angular/forms';
import {InterviewStreamService} from '../student/interview/services/interview.service';
import {InterviewDataService} from '../student/interview/services/interview-data.service';
import {Question} from '../models/Question';
import {Interview} from '../models/Interview';
import{VgApiService} from "@videogular/ngx-videogular/core";

declare var window:any;

@Component({
    selector: 'mgr-replay-responses',
    templateUrl: './mgr-replay-responses.component.html',
    standalone: false
})

export class ManagerReplayResponseListComponent {

    form: UntypedFormGroup;

    @Input() currentAttempt: any;
    @Output() getQuestion: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('media', {static:false}) stream: any;
    @ViewChild('playback', {static:false}) playback: any;
    responseApi: VgApiService;
    playbackApi: VgApiService;
    autoplay: boolean;
    answers: boolean;
    repeat: boolean;
    questionTotal: any;
    questions: Question[];
    attempt: any;
    currentIndex: number = 0;
    currentItem: any;
    ratingClicked: number;
    itemIdRatingClicked: string;
    interview_title: string;
    reviewer: any = false;
    requested: any = false;
    playing: any = false;
    selected: any;

    /* direct copy of student replay responses due to time constraints.
        will have to extract common parts and collect them into one class
        for use on manager and student side when time permits */

    constructor(private _videoService: InterviewStreamService,
                public _dataService: InterviewDataService,
                private _activatedRoute: ActivatedRoute,
                private _route: Router,
                private fb: UntypedFormBuilder) {
    }

    ngOnChanges() {
        if (this.currentAttempt) {
            this.startPlayback();
        }
    }

    startPlayback() {
        this.currentIndex = this.currentIndex || 0;
        this.attempt = this.currentAttempt;
        this.interview_title = this.attempt.video_interview.title;
        this.questions = this.attempt.questions;
        this.questionTotal = (this._dataService.practice) ? 1 : this.questions.length;
        this._dataService.attemptId = this.attempt.video_interview_attempt_id;
        this.loadQuestion(this.currentIndex);
    }

    onPlayerReady(api: VgApiService) {
        this.responseApi = api;
    }

    onPlaybackReady(api: VgApiService) {
        this.playbackApi = api;
    }

    ngAfterViewInit() {
        if (this._dataService.practice) {
            this.playing = true;
            this.stream.nativeElement.play();
            this.responseApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                    this.playback.nativeElement.play();
                    this.playing = false;
                }
            );
            this.playbackApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                    this.playing = true;
                }
            );
        } else {
            this.updateResponseState({autoplay: false, answers: false, repeat: false});
        }
    }

    prevQuestion() {
        if (!this.questions[this.currentIndex - 1])
            return;
        this.currentIndex = (this.repeat) ? this.currentIndex : this.currentIndex -= 1;
    }

    nextQuestion (currentIndex: number) {
        if (!this.questions[this.currentIndex + 1])
            return;
        this.currentIndex = (this.repeat) ? this.currentIndex : this.currentIndex += 1;
    }

    loadQuestion(idx = this.currentIndex) {
        let video;
        this.currentIndex = idx;
        this.currentItem = this.questions[this.currentIndex];
        this.updateSteps(idx);
        if (this.stream) {
            this.stream.nativeElement.src = (!this.answers) ? this.currentItem.question_file : '';
        }
        if (this.playback) {
            this.playback.nativeElement.src = this.currentItem.answer_file;
        }
        document.querySelector<HTMLElement>('h2.question-title')?.focus();
        this.sendCurrentQuestionToParent(this.currentItem);
        this.playing = (this.answers) ? false : true;
    }

    updateSteps(index) {
        let count = 0;
        this.questions.forEach((q:any) => {
            q.selected = false;
            if (count <= index) {
                q.selected = true;
                count++;
            }
        })
    }

    updateResponseState(state) {

        // the fix for the expression changed error requires using setTimeout

        setTimeout(() => {
            this._dataService.updateResponseState(state);
            this._dataService.reviewStates.subscribe(states => {
                this.autoplay = states.autoplay;
                this.answers = states.answers;
                this.repeat = states.repeat;

                if (this.autoplay && this.answers) {
                    this.playing = false;
                    this.playback.nativeElement.play();
                    this.playbackApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                        this.playing = false;
                        this.playback.nativeElement.pause();
                    });
                }

                if (this.autoplay && !this.answers) {
                    this.responseApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                            this.playing = false;
                            this.playback.currentTime = 0;
                            this.playback.nativeElement.play();
                        }
                    );

                    this.playbackApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                            this.playing = true;
                            this.playback.currentTime = 0;
                            this.stream.nativeElement.pause();
                        }
                    );

                }

                if (!this.answers && !this.autoplay) {
                    this.responseApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                        this.playing = false;
                        this.playback.currentTime = 0;
                        this.playback.nativeElement.load();
                    });
                    this.playbackApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                        this.playing = true;
                        this.stream.currentTime = 0;
                        this.stream.nativeElement.load();
                    });
                }

                if (this.answers && !this.autoplay) {
                    this.playing = false;
                    this.playback.nativeElement.load();
                    this.playbackApi.getDefaultMedia().subscriptions.ended.subscribe(() => {
                        this.playing = false;
                        this.nextQuestion(this.currentIndex);
                    });
                }
            });
        });
    }

    deleteAttempt(id) {
      if (confirm('Are you ABSOLUTELY SURE you wish to do this?')) {
        this._dataService.deleteInterview(id);
        this.backToList();
      } else {
          return;
      }
    }

    backToList() {
        window.parent.location = '/manager?mode=list&';
    }

    sendCurrentQuestionToParent(question) {
        this.getQuestion.emit(question);
    }

}
